"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Redirect = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = require("react");
var Redirect = function (_a) {
    var to = _a.to, push = _a.push;
    var navigate = (0, ui_tools_1.useNavigate)();
    (0, react_1.useEffect)(function () {
        if (push) {
            navigate(to);
        }
        else {
            navigate(to, { replace: true });
        }
    }, [navigate, push, to]);
    return null;
};
exports.Redirect = Redirect;
